import Vue from 'vue'
import moment from 'moment'

export const formatDate = (value, format = "HH:mm:ss DD/MM/YYYY") => {
    return moment(value * 1000).format(format)
}

Vue.filter("date", formatDate);

export const formatDateRecent = (value, format = "DD/MM/YYYY") => {
    const date = moment(value * 1000);
    const now = moment(new Date().getTime());
    if (now.isBefore(moment(value * 1000).add(1, 'days'))) {
        return date.fromNow()
    } else if (now.isBefore(moment(value * 1000).add(30, 'days'))) {
        return date.format("HH:mm DD/MM/YYYY")
    } else {
        return date.format(format)
    }
}

Vue.filter("recent", formatDateRecent)
